import { GET_AUTH } from '../Actions/types'


const initialState = {
    is_authenticated: null,
}

export default function (state = initialState, action) {
    switch(action.type) {
        case GET_AUTH: 
            return {
             ...state,
               is_authenticated: action.payload
            };
    
        default: 
            return state;
    }
}


// WEBPACK FOOTER //
// ./src/Reducers/AuthReducer.js